<script setup>
import 'reset-css';
import '@/assets/styles/base/index.scss';
import 'vue-final-modal/style.css';

import { ModalsContainer } from 'vue-final-modal';

import hours12Codes from '@/config/hours-12-codes';
import localStorageKeys from '@/constants/local-storage-keys';
import routes from '@/constants/routes';
import cookieKeys from '@/constants/cookie-keys';
import { timeFormatKeys } from '@/constants/time-format';

// i18n seo
const head = useLocaleHead({
  addSeoAttributes: true,
});
useHead({
  htmlAttrs: () => head.value.htmlAttrs,
});

// Cookies
const authStore = useAuthStore();

const showCookiesBanner = ref(false);
const isCookiesAccepted = useLocalStorage(
  localStorageKeys.COOKIES_ACCEPTED,
  false,
);

const route = useRoute();

async function initMetrics() {
  const {
    public: { gtmID },
  } = useRuntimeConfig();

  const metrics = useMetrics({ gtmID });
  metrics.init();

  if (isCookiesAccepted.value) {
    try {
      await gtagPushConsent('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
      });

      await authStore.updateSessionInformation();
    } catch (error) {
      console.log(error);
    }
  }
}

// time format
const timeFormatCookie = useCookie(cookieKeys.TIME_FORMAT);

function getUserTimeFormat() {
  return authStore.countryId &&
    hours12Codes.includes(authStore.countryId.toUpperCase())
    ? timeFormatKeys.HOURS_12
    : timeFormatKeys.HOURS_24;
}

onMounted(() => {
  initMetrics();

  if (!timeFormatCookie.value)
    timeFormatCookie.value = String(getUserTimeFormat());
});

watch(
  () => route.path,
  (routePath) => {
    setTimeout(() => {
      showCookiesBanner.value = !routePath.includes(routes.CART_PROCESSING);
    }, 5000);
  },
  { immediate: true },
);
</script>

<template>
  <div id="app" class="app">
    <NuxtLayout v-slot="{ className }" class="app__layout">
      <NuxtPage :class="className" />
    </NuxtLayout>

    <ClientOnly>
      <ModalsContainer />

      <Transition name="fade">
        <BundlesCookies
          v-if="!isCookiesAccepted && showCookiesBanner"
          class="app__cookies"
        />
      </Transition>
    </ClientOnly>
  </div>
</template>
